<div class="voicemail-greeting-container">
  @if (!voicemail.voicemail.greetings) {
  <div>
    <div class="mat-body-1 m-b-12">You don’t currently have a custom greeting.</div>
    <button mat-flat-button class="add-greeting-button" color="primary" (click)="togglePanel()">
      Add a greeting
    </button>
  </div>
  } @else {
  <div class="mat-body-1 m-b-12">Current greeting</div>
  <div class="onsip-grid-placement-shelf">
    @if (voicemail.voicemail.greetings && audioUrl) {
    <span class="voicemail-greetings-audio-container">
      <audio
        class="voicemail-greetings-audio"
        controls
        controlsList="nodownload"
        [src]="audioUrl | safeSrc"
      ></audio>
      <a
        id="admin-voicemail-greeting-download"
        [href]="audioUrl | safeSrc"
        download
        type="audio/wav"
      >
        <mat-icon class="voicemail-download-icon" aria-label="download_greetings">get_app</mat-icon>
      </a>
      <button mat-button class="replace-button" color="primary" (click)="togglePanel()">
        Replace
      </button>
    </span>
    }
  </div>
  }
</div>
